
<li>
  <div class="flexRow align-center tree-node">
    <span
      v-if="checkBox"
      @click="selectCheckBox(tree)"
      class="button chk cursor"
      :class="tree.checked ? 'checkbox_true_full' : 'checkbox_false_full'"
      :style="tree.disabled ? 'cursor: not-allowed;' : ''"
    ></span>

    <a
      class="flex-item-1"
      target="_blank"
      style=""
      @click="selectNode"
      :class="aClass()"
      :title="tree.name"
    >
      <!--          <span :title="tree.name" class="button" :class="iconCss()" :style="load()"></span>-->
      <!--          v-tooltip.top="{-->
      <!--          content:tree.name,-->
      <!--          classes:'tree-tooltip-box',-->
      <!--          offset:10-->
      <!--          }"-->
      <template v-if="isShowResourceNum">
        <span class="node_name" :class="tree.checked ? 'active' : ''">
          {{ tree.name | filterText(textMaxLength) }}
          <!-- <template v-if="tree.resourceNum">({{ tree.resourceNum }})</template> -->
        </span>
      </template>
      <span v-else class="node_name" :class="tree.checked ? 'active' : ''">{{ tree.name }}</span>
    </a>
    <span
      v-if="vif()"
      title=""
      @click="vShow(tree)"
      class="button switch"
      :class="vTreeFirstSpan()"
    ></span>
    <!--        <span v-else title="" class="button switch "-->
    <!--              :class="classes()"></span>-->
  </div>

  <ul class="level-ul" :class="line">
    <yejin-tree-core
      v-for="(tr, i) in tree.children"
      v-show="tree.open"
      :key="i"
      :checkBoxType="checkBoxType"
      :allOpen="tr.allOpen"
      :first="false"
      :checkBox="checkBox"
      :nodeTrigger="nodeTrigger"
      :index="i"
      :tree="tr"
      :currentArray="tree.children"
      :parentTree="tr.parentTree"
      :rootData="rootData"
      :clickNode="clickNode"
      @checkedBoxV="checkedBoxV"
      :beforeClick="beforeClick"
      :checkBoxCallInit="checkBoxCallInit"
      :checkBoxCall="checkBoxCall"
      :last="tree.children.length - 1 === i"
      :hiddenLine="tr.hiddenLine"
      :async="async"
      :asyncCall="asyncCall"
      :isShowResourceNum="isShowResourceNum"
    />
  </ul>
</li>
